export default "__VITE_ASSET__CpWzZJ5s__"